import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

const STATUS_LABELS: Record<string, string> = {
  TIDAK_DIKETAHUI: 'Status Tidak Diketahui',
  VERIFIKASI_BERKAS: 'Verifikasi Berkas',
  DIPANGGIL_WAWANCARA: 'Dipanggil Wawancara',
  KEPUTUSAN_DITERIMA: 'Keputusan Diterima',
  KEPUTUSAN_DITOLAK: 'Keputusan Ditolak',
}

const props = __props

const label = computed(() => STATUS_LABELS[props.status] ?? props.status)

const badgeClass = computed(() => ({
  'bg-yellow-100 text-yellow-700': props.status === 'VERIFIKASI_BERKAS',
  'bg-blue-100 text-blue-700':     props.status === 'DIPANGGIL_WAWANCARA',
  'bg-green-100 text-green-700':   props.status === 'KEPUTUSAN_DITERIMA',
  'bg-red-100 text-red-700':       props.status === 'KEPUTUSAN_DITOLAK',
  'bg-slate-100 text-slate-500':   props.status === 'TIDAK_DIKETAHUI' || !STATUS_LABELS[props.status],
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold", badgeClass.value])
  }, _toDisplayString(label.value), 3))
}
}

})